import { ICON_TYPES } from '../constants';

export const ArrowLeftTriangle = (): JSX.Element => {
  return (
    <svg
      width="8"
      height="10"
      viewBox="0 0 8 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 4.99316L8 10V0L0 4.99316Z" fill="#0F3E32" />
    </svg>
  );
};

ArrowLeftTriangle.iconType = ICON_TYPES.ARROW_LEFT_TRIANGLE;
